import { forIn } from "lodash";
import type { IrMap } from "./IrMap";
import { ResolutionMode } from "./ResolutionMode";

export class ResolutionModeFunctions {
    public static GetResolutionModes(): ResolutionMode[] {
        const resolutionsModes: ResolutionMode[] = [];
        forIn(ResolutionMode, (key) => {
            if (typeof key === "number") {
                resolutionsModes.push(key as any as ResolutionMode);
            }
        });
        return resolutionsModes;
    }

    public static GetResolutionModesDictionary(): IrMap<ResolutionMode, string> {
        return this.GetResolutionModes().map((rm) => ({ key: rm, value: ResolutionMode[rm] }));
    }

    public static GetSupportedResolutionModesDictionary(
        resolutionModes: ResolutionMode[],
    ): IrMap<ResolutionMode, string> {
        return resolutionModes.map((rm) => ({ key: rm, value: ResolutionMode[rm] }));
    }
}
